export const yellow = '#FFC425'
export const branding = '#5b5bfc'
export const blue = '#8AB7E9'
export const button = 'black'
export const newsEvents = 'black'
